import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { selfServiceRouter } from 'src/routes/routes';
import DashBoardMenu from 'src/components/app/DashBoardMenu';
import LimitedWidthPage from 'src/components/PageWrappers/LimitedWidthPage';
import useRoutes from 'src/routes/useRoutes';
const Absence = lazy(() => import('../Absences'));
const Dashboard = lazy(() => import('./Dashboard'));
const EmployeesReport = lazy(() => import('../Reports/WorkInDepartments'));
const Planner = lazy(() => import('../Planner'));
const SummaryReport = lazy(() => import('../Reports/WorkTimeSummary'));
const WorkByDaysReport = lazy(() => import('../Reports/WorkTimesByDays'));
function SelfServiceMenu() {
    const { getAllowedRoutes } = useRoutes();
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "/selfService/myDashboard", component: Dashboard }),
        React.createElement(Route, { path: "/selfService/myPlanner" }, (props) => (React.createElement(Planner, { ...props, selfServiceMode: true }))),
        React.createElement(Route, { path: "/selfService/myAbsences" }, (props) => (
        // @ts-ignore
        React.createElement(Absence, { ...props, selfServiceMode: true }))),
        React.createElement(Route, { path: "/selfService/myEmployeesReport" }, (props) => (React.createElement(EmployeesReport, { ...props, selfServiceMode: true }))),
        React.createElement(Route, { path: "/selfService/myWorkByDaysReport" }, (props) => (
        // @ts-ignore
        React.createElement(WorkByDaysReport, { ...props, selfServiceMode: true }))),
        React.createElement(Route, { path: "/selfService/mySummaryReport" }, (props) => (React.createElement(SummaryReport, { ...props, selfServiceMode: true }))),
        React.createElement(Route, { path: "/selfService" }, () => (React.createElement(LimitedWidthPage, null,
            React.createElement(DashBoardMenu, { gridWidth: 950, routes: getAllowedRoutes(selfServiceRouter.subPages), sortAlphabetically: true }))))));
}
export default SelfServiceMenu;
